const actions = {
  CREATE_MEMBER_BEGIN: "CREATE_MEMBER_BEGIN",
  CREATE_MEMBER_SUCCESS: "CREATE_MEMBER_SUCCESS",
  CREATE_MEMBER_ERR: "CREATE_MEMBER_ERR",

  LIST_MEMBERS_BEGIN: "LIST_MEMBERS_BEGIN",
  LIST_MEMBERS_SUCCESS: "LIST_MEMBERS_SUCCESS",
  LIST_MEMBERS_ERR: "LIST_MEMBERS_ERR",

  UPDATE_MEMBER_BEGIN: "UPDATE_MEMBER_BEGIN",
  UPDATE_MEMBER_SUCCESS: "UPDATE_MEMBER_SUCCESS",
  UPDATE_MEMBER_ERR: "UPDATE_MEMBER_ERR",

  DELETE_MEMBER_BEGIN: "DELETE_MEMBER_BEGIN",
  DELETE_MEMBER_SUCCESS: "DELETE_MEMBER_SUCCESS",
  DELETE_MEMBER_ERR: "DELETE_MEMBER_ERR",

  BLOCK_MEMBER_BEGIN: "BLOCK_MEMBER_BEGIN",
  BLOCK_MEMBER_SUCCESS: "BLOCK_MEMBER_SUCCESS",
  BLOCK_MEMBER_ERR: "BLOCK_MEMBER_ERR",

  UNBLOCK_MEMBER_BEGIN: "UNBLOCK_MEMBER_BEGIN",
  UNBLOCK_MEMBER_SUCCESS: "UNBLOCK_MEMBER_SUCCESS",
  UNBLOCK_MEMBER_ERR: "UNBLOCK_MEMBER_ERR",

  GET_MEMBER_DETAILS_BEGIN: "GET_MEMBER_DETAILS_BEGIN",
  GET_MEMBER_DETAILS_SUCCESS: "GET_MEMBER_DETAILS_SUCCESS",
  GET_MEMBER_DETAILS_ERR: "GET_MEMBER_DETAILS_ERR",

  GET_MEMBER_SUBSCRIPTIONS_BEGIN: "GET_MEMBER_SUBSCRIPTIONS_BEGIN",
  GET_MEMBER_SUBSCRIPTIONS_SUCCESS: "GET_MEMBER_SUBSCRIPTIONS_SUCCESS",
  GET_MEMBER_SUBSCRIPTIONS_ERR: "GET_MEMBER_SUBSCRIPTIONS_ERR",

  createMemberBegin: () => {
    return {
      type: actions.CREATE_MEMBER_BEGIN,
    };
  },

  createMemberSuccess: (data) => {
    return {
      type: actions.CREATE_MEMBER_SUCCESS,
      data,
    };
  },

  createMemberErr: (err) => {
    return {
      type: actions.CREATE_MEMBER_ERR,
      err,
    };
  },

  listMembersBegin: () => {
    return {
      type: actions.LIST_MEMBERS_BEGIN,
    };
  },

  listMembersSuccess: (data) => {
    return {
      type: actions.LIST_MEMBERS_SUCCESS,
      data,
    };
  },

  listMembersErr: (err) => {
    return {
      type: actions.LIST_MEMBERS_ERR,
      err,
    };
  },

  updateMemberBegin: () => {
    return {
      type: actions.UPDATE_MEMBER_BEGIN,
    };
  },

  updateMemberSuccess: (data) => {
    return {
      type: actions.UPDATE_MEMBER_SUCCESS,
      data,
    };
  },

  updateMemberErr: (err) => {
    return {
      type: actions.UPDATE_MEMBER_ERR,
      err,
    };
  },

  deleteMemberBegin: () => {
    return {
      type: actions.DELETE_MEMBER_BEGIN,
    };
  },

  deleteMemberSuccess: (data) => {
    return {
      type: actions.DELETE_MEMBER_SUCCESS,
      data,
    };
  },

  deleteMemberErr: (err) => {
    return {
      type: actions.DELETE_MEMBER_ERR,
      err,
    };
  },

  blockMemberBegin: () => {
    return {
      type: actions.BLOCK_MEMBER_BEGIN,
    };
  },

  blockMemberSuccess: (data) => {
    return {
      type: actions.BLOCK_MEMBER_SUCCESS,
      data,
    };
  },

  blockMemberErr: (err) => {
    return {
      type: actions.BLOCK_MEMBER_ERR,
      err,
    };
  },

  unblockMemberBegin: () => {
    return {
      type: actions.UNBLOCK_MEMBER_BEGIN,
    };
  },

  unblockMemberSuccess: (data) => {
    return {
      type: actions.UNBLOCK_MEMBER_SUCCESS,
      data,
    };
  },

  unblockMemberErr: (err) => {
    return {
      type: actions.UNBLOCK_MEMBER_ERR,
      err,
    };
  },

  getMemberDetailsBegin: () => {
    return {
      type: actions.GET_MEMBER_DETAILS_BEGIN,
    };
  },

  getMemberDetailsSuccess: (data) => {
    return {
      type: actions.GET_MEMBER_DETAILS_SUCCESS,
      data,
    };
  },

  getMemberDetailsErr: (err) => {
    return {
      type: actions.GET_MEMBER_DETAILS_ERR,
      err,
    };
  },

  getMemberSubscriptionsBegin: () => {
    return {
      type: actions.GET_MEMBER_SUBSCRIPTIONS_BEGIN,
    };
  },

  getMemberSubscriptionsSuccess: (data) => {
    return {
      type: actions.GET_MEMBER_SUBSCRIPTIONS_SUCCESS,
      data,
    };
  },

  getMemberSubscriptionsErr: (err) => {
    return {
      type: actions.GET_MEMBER_SUBSCRIPTIONS_ERR,
      err,
    };
  },
};

export default actions;
